import { useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Textblocks } from "@/services/backend/textblocks/components/textblocks";
import { useRltCalculationShowQuery } from "@/services/backend/rlt/calculations/api/calculation-api";
import { GSMSubdomain } from "@/shared/types/gsm-subdomain";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { TreatmentRemark } from "@/services/backend/rlt/treatments/components/treatment-remark";

export function TextblocksRoute() {
  const { calculationId } = useParams();
  const { data, isLoading, error } = useRltCalculationShowQuery({
    id: calculationId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return null;
  }

  return (
    <div className="grid gap-2">
      <TreatmentRemark treatmentId={data!.treatmentId} />
      <Textblocks
        subdomain={GSMSubdomain.RLT}
        documentKind={GSMDocumentKind.Treatment}
        documentId={data!.treatmentId}
      />
    </div>
  );
}
